module.exports = __webpack_public_path__ + "img/def.7f7244ae.jpg";